if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
function initStativTextGuide() {
  const sizeSelector = document.querySelector('select[name*="Størrelse"], select[name*="Size"]');
  const textBox = document.getElementById("stativ-guide-text");
  if (!sizeSelector || !textBox) return;

  const stativGuide = {
    "18 cm.": "Til 18 cm plisséskærme anbefaler vi:<br>– Mini klemmestativ (E-14)<br>– Lille satellitstativ (E-14)",
    "20 cm.": "Til 20 cm plisséskærme passer:<br>– Stort satellitstativ<br>– Lille klemmestativ<br>– Lille liggestativ",
    "22 cm.": "Til 22 cm plisséskærme passer:<br>– Stort satellitstativ<br>– Lille klemmestativ<br>– Lille liggestativ",
    "24 cm.": "Til 24 cm plisséskærme passer:<br>– Stort satellitstativ<br>– Lille klemmestativ<br>– Lille liggestativ",
    "26 cm.": "Til 26 cm plisséskærme passer:<br>– Stort satellitstativ<br>– Stort klemmestativ<br>– Stort liggestativ",
    "28 cm.": "Til 28 cm plisséskærme passer:<br>– Stort satellitstativ<br>– Stort klemmestativ<br>– Stort liggestativ",
    "30 cm.": "Til 30 cm plisséskærme passer:<br>– Stort satellitstativ<br>– Stort klemmestativ<br>– Stort liggestativ",
    "32 cm.": "Til 32 cm plisséskærme passer:<br>– Stort satellitstativ<br>– Stort klemmestativ<br>– Stort liggestativ",
    "34 cm.": "Til 34 cm plisséskærme passer:<br>– Stort satellitstativ<br>– Stort klemmestativ<br>– Stort liggestativ",
    "36 cm.": "Til 36 cm plisséskærme passer:<br>– Stort satellitstativ<br>– Stort klemmestativ<br>– Stort liggestativ",
    "38 cm.": "Til 38 cm plisséskærme passer:<br>– Stort satellitstativ<br>– Stort klemmestativ<br>– Stort liggestativ"
  };

  function updateGuide() {
    const size = sizeSelector.value;
    textBox.innerHTML = stativGuide[size] || "Vælg en størrelse for at se passende stativer.";
  }

  updateGuide();
  sizeSelector.addEventListener("change", updateGuide);
}

document.addEventListener("DOMContentLoaded", initStativTextGuide);
document.addEventListener("shopify:section:load", initStativTextGuide);
